import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';

// SERVICES
import { CuentasService } from 'src/app/services/cuentas_maestras.service';

@Component({
  selector: 'app-editar-cuentas',
  templateUrl: './editar-cuentas.component.html',
  styleUrls: ['./editar-cuentas.component.scss'],
})
export class EditarCuentasComponent implements OnInit {
  form = this.fb.group({
    id_cuentas: [],
    titular: [
      '',
      [
        Validators.required,
      ],
    ],
    tipo_documento: ['', [Validators.required, Validators.maxLength(1)]],
    numero_documento_cuenta: [
      '',
      [
        Validators.required,
        Validators.pattern('^[0-9]*$')
      ],
    ],
    pago_movil: [
      '',
      [
        Validators.maxLength(11),
        Validators.minLength(11),
        Validators.pattern('^[0-9]*$'),
      ],
    ],
    numero_cuenta: ['', [Validators.pattern('^[0-9]*$')]],
    tipo_cuenta: ['Corriente'],
    borrado: [0],
    id_usuarios_creador: [sessionStorage.getItem('id_usuario')],
  });

  tiposDocumentos: any = [{ name: 'V' }, { name: 'J' }, { name: 'E' }, { name: 'G' }, { name: 'C' }];

  constructor(
    public dialogRef: MatDialogRef<EditarCuentasComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _snackBar: MatSnackBar,
    private cuentasService: CuentasService
  ) {
    this.form.controls.titular.setValue(this.data.titular);
    this.form.controls.tipo_documento.setValue(this.data.tipo_documento);
    this.form.controls.numero_documento_cuenta.setValue(this.data.numero_documento_cuenta);
    this.form.controls.pago_movil.setValue(this.data.pago_movil);
    this.form.controls.numero_cuenta.setValue(this.data.numero_cuenta);
    this.form.controls.tipo_cuenta.setValue(this.data.tipo_cuenta);
    this.form.controls.id_cuentas.setValue(this.data.id_cuentas);
  }

  ngOnInit(): void {}
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  onSubmit() {
    //console.log(this.form.value);
    this.cuentasService.actualizar(this.form.value).subscribe((data) => {
      //console.log(data);
      this.openSnackBar('Tipo Operación actualizado con éxito', 'X');
      this.dialogRef.close();
    });
  }
}
